<div>
    <h2 mat-dialog-title>Change User</h2>
    <div>
        <form [formGroup]="consumerForm">
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Assigned</mat-label>
                <input type="text"
                       placeholder="User"
                       aria-label="User"
                       matInput
                       formControlName="consumerId"
                       [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="searchUserService.displayResult.bind(this)">
                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                        {{ commonService.getFullName(option?.firstName, option?.lastName) }}
                      </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="consumerForm.controls['consumerId'].touched && consumerForm.controls['consumerId'].hasError('required')">
                    This is a required field.</mat-error>
              </mat-form-field>
        </form>


        <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        
            <button mat-button class="sub-button" (click)="changeConsumer()"><span>Change</span></button>
            <button mat-button mat-dialog-close class="can-button" (click)="onNoClick()"><span>Close</span></button>
        </div>
    </div>
</div>
